import { useCallback } from 'react';
import { Route } from 'react-router';
import {
  AppMode,
  AppModeProvider,
} from '../../components/app/app-mode-provider';
import { Page } from '../../pages/page';
import { BeaconRouterContextProvider } from '../../route/route.hooks';
import {
  Route as BeaconRoute,
  RouteBuilderFactory,
} from '../../route/route.types';
import { DirectConnectMachinePage } from '../page/direct-connect-machine.page';
import { DirectConnectSelectMachinePage } from '../page/direct-connect-select-machine.page';
import { DirectConnectKioskRoute } from './direct-connect-kiosk-route';
import { DirectConnectRouteBuilder } from './direct-connect-route-builder';

const builder = new DirectConnectRouteBuilder();

const DirectConnectRoutes = () => {
  const routeBuilderFactory = useCallback<RouteBuilderFactory>(() => {
    return builder;
  }, []);

  return (
    <AppModeProvider mode={AppMode.DIRECT}>
      <BeaconRouterContextProvider routeBuilderFactory={routeBuilderFactory}>
        <Page
          path={`${BeaconRoute.DIRECT_CONNECT}/machine/:machineId`}
          i18nTitleKey={'common:direct_connect'}
          component={DirectConnectMachinePage}
        />
        <Page
          path={`${builder.getDirectConnectSelectMachineRoute()}`}
          i18nTitleKey={'common:direct_connect_select_robot'}
          component={DirectConnectSelectMachinePage}
          exact
        />
        <Route
          path={`${builder.getDirectConnectKioskRoute()}`}
          component={DirectConnectKioskRoute}
          exact
        />
      </BeaconRouterContextProvider>
    </AppModeProvider>
  );
};

export { DirectConnectRoutes };
